export const getFormattedPrice = (price: number, currency = 'TL'): string =>
  `${price} ${currency}`;

export const getFormattedFailurePrice = (
  failurePrice: number,
  currency = 'TL'
): string => `${failurePrice} ${currency}`;

export const beautifyPrice = (price: number, currency = 'TL'): string =>
  `${price.toLocaleString('tr-TR')} ${currency}`;
